import React, { useState } from 'react';
const faqs = [{
  q: 'Is the material suitable for both Matwork and apparatus classes?',
  a: 'Yes — the Vault covers Matwork (mat-based) and Small Props integration, with principles that are fully applicable to Reformer and large apparatus classes too.'
}, {
  q: 'Are the 6 bonuses included in the $29 AUD price?',
  a: "Absolutely. If you order today, you receive the complete bonus package at no extra cost — that's $552 AUD of value for $29."
}, {
  q: 'How do I receive the material?',
  a: "Immediately after payment, you'll receive an email with the link to download all files as high-resolution PDFs. Instant digital delivery."
}, {
  q: 'What if I have students at different levels in the same class?',
  a: 'The Vault includes specific progressions and regressions, so you can adapt the same exercise for a beginner and an advanced student in the same room.'
}, {
  q: "I'm a new instructor — is this still right for me?",
  a: 'Perfect for both new instructors and seasoned pros. The structure gives you instant confidence and walks you through every level, with no gaps in the methodology.'
}, {
  q: 'Can I use it for 1-on-1 private sessions?',
  a: 'Yes. The postural assessment sheets and clinical protocols are designed specifically to personalise individual sessions to the highest standard.'
}, {
  q: 'Is the payment secure? Which methods can I use?',
  a: 'Payment is processed on a fully encrypted (SSL) checkout. We accept all major credit cards, PayPal, and Apple/Google Pay. No subscriptions or auto-renewals — it is a single payment.'
}, {
  q: 'Do I need to install anything or create an account?',
  a: "No. You receive the PDFs directly via email. They work on tablet, smartphone, PC, and they're print-ready in A4. Zero technical friction."
}, {
  q: 'How long will I have access to the material?',
  a: 'Forever. Once downloaded, the files are yours for life. No expiry, no subscription.'
}, {
  q: 'Can I really request a refund within 14 days?',
  a: "Yes — no questions asked. If within 14 days you don't feel your work has become easier, just email us and we'll refund 100%."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-24 px-4" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main text-center mb-12 tracking-tight" data-id="element-76">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4 mb-16" data-id="element-77">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-white border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/30 shadow-[0_4px_15px_rgba(201,137,155,0.05)]' : 'border-border-light hover:border-primary/20'}`} data-id="element-78">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-79">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-80">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-81">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-82">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-83">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-84">
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_8px_25px_rgba(16,185,129,0.25)]" data-id="element-85">
            👉 YES! GIVE ME ACCESS TO THE VAULT NOW
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-86">
            <span data-id="element-87">⚡ Instant Digital Access</span>
            <span data-id="element-88">•</span>
            <span data-id="element-89">🛡️ 14-Day Guarantee</span>
          </p>
        </div>
      </div>
    </section>;
}